import { experimental_extendTheme as extendTheme } from "@mui/material";
import { deepmerge } from "@mui/utils";
import { createTidalThemeOptions } from "./createTidalThemeOptions.js";
function createTidalTheme(customThemeOptions = {}, colorMode = "light") {
  const themeOptions = deepmerge(createTidalThemeOptions(colorMode), customThemeOptions, {
    clone: true
  });
  if (themeOptions.vars) delete themeOptions.vars;
  return extendTheme(themeOptions);
}
export {
  createTidalTheme
};
//# sourceMappingURL=createTidalTheme.js.map
